import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const CargoLoadOptimizerAccess = () => {
  return (
    <div className={styles.wrapperInputs}>
      <FormFieldControlled
        rules={VALIDATION_SCHEMA.toolInfo.required}
        labelTitle="How many calculations are you planning to make per month?"
        fieldName={INPUT_FIELD_NAMES.apiPerMonth}
        className={styles.inputCalc}
      />
      <FormFieldControlled
        rules={VALIDATION_SCHEMA.toolInfo.required}
        labelTitle="How many licenses (subaccounts) do you need?"
        fieldName={INPUT_FIELD_NAMES.cargoLoadOptimizerLicences}
        className={styles.inputLicense}
      />
    </div>
  );
};
